import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { NzSelectPlacementType } from 'ng-zorro-antd/select';

@Component({
  selector: 'app-input-taimepicker',
  templateUrl: './input-taimepicker.component.html',
  styleUrl: './input-taimepicker.component.scss',
})
export class InputTaimepickerComponent {
  @Input() placeholder: string = 'Select a date';
  @Input() isDisabled: boolean = false;
  @Input() label: string = '';
  @Input() control: FormControl = new FormControl();

  @Input() size: 'default' | 'large' | 'small' = 'small';
  @Input() placement: NzSelectPlacementType = 'topLeft';
  time: Date | null = null;
  defaultOpenValue = new Date(0, 0, 0, 0, 0, 0);

  isRequired(control: AbstractControl | null): boolean {
    if (!control || !control.validator) {
      return false;
    }
    const validator = control.validator({} as AbstractControl);
    return validator && validator['required'] ? true : false;
  }
}
